import $ from "jquery";
window.$ = window.jQuery = $;

require('./swiper');
require('./form');
require('./galleryGood');
import Inputmask from "inputmask";
import 'jquery-validation';
import 'slick-carousel';
import WheelIndicator from 'wheel-indicator';
window.WheelIndicator = WheelIndicator;
import 'select2';

$(document).ready(function () {


    $('.js_nova-post-unit').select2({
    width: '100%',
    sorter: function(data) {
        const term = $('.select2-search__field').val()?.toLowerCase() || '';

        return data.sort((a, b) => {
            const aText = a.text.toLowerCase();
            const bText = b.text.toLowerCase();

            const aStarts = aText.startsWith(term);
            const bStarts = bText.startsWith(term);

            if (aStarts && !bStarts) return -1;
            if (!aStarts && bStarts) return 1;

            return aText.localeCompare(bText);
        });
    }
});


    function initPhoneMask() {
        const im = new Inputmask("+38 099 999 99 99", {
            clearIncomplete: true,
            showMaskOnHover: false,
        });

        im.mask($('input[name="phone"]'));
    }
    window.initPhoneMask = initPhoneMask;
    initPhoneMask()


    $('.js-open-spoiler').on('click', function () {
        var currentItem = $(this).closest('.spoiler__item');

        $('.spoiler__item').not(currentItem).find('.spoiler__item-content').slideUp();
        $('.spoiler__item').not(currentItem).find('.spoiler__btn').removeClass('rotate');


        $(this).closest('.spoiler__item').find('.spoiler__item-content').slideToggle();
        $(this).find('.spoiler__btn').toggleClass('rotate');
    });

    $('.header-burger-menu').click(function(){
        $('body').toggleClass('hidden')
        $('.header__mob-wrap').fadeToggle();
        $('.header-burger-menu').toggleClass('active');
    });


});
